<template>
    <div  v-if="page && page.acf">
        <div v-for="(campo, i) in page.acf" :key="i" >
            <div v-for="(modulo, i2) in campo" :key="i2">
                <component v-bind:is="modulo.acf_fc_layout" :data="modulo"></component>
            </div>
        </div>

        <b-modal id="video-modal" size="lg" centered hide-footer hide-header @shown="playVideo" @hidden="stopVideo">
            <iframe width="100%"  allowfullscreen wmode="Opaque" style="height:calc(100vh / 2)" :src="'https://www.youtube.com/embed/' + videoId + '?autoplay=1&loop=1&rel=0&wmode=transparent'" frameborder="0" allow="autoplay; encrypted-media" v-if="videoId"></iframe>
        </b-modal>
    </div>

</template>

<script>
import sliderFullwidth from './widgets/slider-fullwidth'
import alguns_cursos from './widgets/alguns_cursos'
import conhecaTime from './widgets/conheca-time'
import newsletter from './widgets/newsletter'
import header_pagina from './widgets/header_pagina'
import texto_titulo_centralizado from './widgets/texto_titulo_centralizado'
import video_fluid from './widgets/video_fluid'
import ano_descricao from './widgets/ano_descricao'
import slider_fotos from './widgets/slider_fotos'
import parceiros from './widgets/parceiros'
import eventos from './widgets/eventos'
import videos from './widgets/videos'
import slider_video from './widgets/slider_video'
import slider_eventos from './widgets/slider_eventos'
import slider_livros from './widgets/slider_livros'
import slider_blog from './widgets/slider_blog'
import unifran from './widgets/unifran'
import contato from './widgets/contato'
import header_concurso from './widgets/header_concurso'
import gerenciador_header from './widgets/gerenciador_header'
import cursos from './widgets/cursos'
import ebooks from './widgets/ebooks'
import autores from './widgets/autores'

export default {
    components:{
        'slider_fullwidth': sliderFullwidth,
        'alguns_cursos': alguns_cursos,
        'conheca-time': conhecaTime,
        'newsletter' : newsletter,
        'header_pagina' : header_pagina,
        'texto_titulo_centralizado' : texto_titulo_centralizado,
        'video_fluid' : video_fluid,
        'ano_descricao' : ano_descricao,
        'slider_fotos' : slider_fotos,
        'parceiros' : parceiros,
        'eventos' : eventos,
        'videos' : videos,
        'slider_video' : slider_video,
        'slider_eventos' : slider_eventos,
        'slider_livros' : slider_livros,
        'slider_blog' : slider_blog,
        'unifran' : unifran,
        'contato' : contato,
        'header_concurso' : header_concurso,
        'gerenciador_header' : gerenciador_header,
        'cursos' : cursos,
        'ebooks' : ebooks,
        'autores' : autores,
    },

    methods:{
        stopVideo(){
            this.$store.commit('setVideoId', null)
        },

        playVideo(){
        }
    },
    
    computed:{
        videoId(){
            return this.$store.state.hub.videoId
        },

        pages(){
            return this.$store.state.page.all
        },

        page(){
            var home = null;

            for (let index = 0; index < this.pages.length; index++) {
                const p = this.pages[index];

                if (p.slug == 'index') {
                    home = p;
                }

                if(p.slug == this.$route.params.page){
                    return p;
                }
                
            }
            
            return home;
        }
    }
}
</script>

<style lang="scss">
    .jumbotron {
        margin-top: 5%; 
    }
</style>


// WEBPACK FOOTER //
// src/components/Home.vue